import { ApiError } from '../../lib/api-client';

/**
 * Traduce un error del API a lenguaje comercial (AGENTS §26). Los 4xx de negocio ya vienen redactados
 * por el back y se muestran tal cual; permisos, sesión y fallas técnicas se reescriben.
 */
export function mensajeDeError(error: unknown, accion: string): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return 'Tu sesión expiró. Ingresa de nuevo para continuar.';
    if (error.status === 403) return `No tienes permiso para ${accion}.`;
    if (error.status >= 500) return `No fue posible ${accion}. Intenta de nuevo en un momento.`;
    return error.message;
  }
  return `No fue posible ${accion}. Intenta de nuevo en un momento.`;
}

/**
 * Validaciones de un 422 de negocio (`PLAN_NO_VALIDO`, feat-26): el back las envía en la raíz del cuerpo
 * (fix-50 · TC-27). Lista vacía si el error no las trae.
 */
export function validacionesDeError(error: unknown): Array<{ code: string; message: string }> {
  if (!(error instanceof ApiError) || error.status !== 422) return [];
  const cuerpo = error.details as { validaciones?: unknown } | null | undefined;
  if (!cuerpo || !Array.isArray(cuerpo.validaciones)) return [];
  return cuerpo.validaciones.filter(
    (v): v is { code: string; message: string } =>
      typeof v === 'object' && v !== null && typeof (v as { message?: unknown }).message === 'string',
  );
}
